import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@one-thd/sui-atomic-components';
import useFilters from '../filter/useFilters';
import FiltersWrapper from '../filter/FiltersWrapper';
import ListLoader from './ListLoader';
import ListPod from './ListPod';
import PaginationWrapper from '../pagination/PaginationWrapper';
import { usePagination } from '../pagination/usePagination';
import { navigate } from '../../utils/util';
import { PAGE_SIZE, DEFAULT_FILTERS, verbiage } from '../../utils/consts';
import { useGiftCards } from '../../hooks/useGiftCards';

const ListWrapperV2 = ({ preSelectedFilters = null }) => {
  const [path, setPath] = useState('');
  const brand = preSelectedFilters?.brand?.[0] || null;
  const { giftCards, errorMsg, loading } = useGiftCards({ brand });
  const [selectedFilters, setSelectedFilters] = useState(preSelectedFilters);
  const filterNames = [verbiage.OCCASION_FILTER, verbiage.CATEGORIES_FILTER, verbiage.BRAND_FILTER];

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const { pathname, search } = window.location;
      setPath(`${pathname}${search}`);
    }
  }, []);

  const { filteredData, allFilters } = useFilters({
    masterData: giftCards,
    filterNames,
    defaultFilters: DEFAULT_FILTERS,
    selectedFilters
  });

  const { paginatedData, currentPage } = usePagination({
    filteredData,
    pageSize: PAGE_SIZE,
    path
  });

  const handlePageChanged = (url) => {
    setPath(url);
    navigate(url);
  };

  const handleFiltersChange = (filters) => {
    // Go back to page 1 once filter changes applied
    if (typeof window !== 'undefined') {
      let params = new URL(`${window.location.origin}${path}`).searchParams;
      params.delete('Nao');
      const search = params.toString();
      const _path = `${window.location.pathname}?${search}`;
      handlePageChanged(_path);
    }
    setTimeout(() => {
      setSelectedFilters(filters);
    });
  };

  const renderPagination = () => {
    return (
      <PaginationWrapper
        href={path}
        listLength={filteredData?.length || 0}
        page={currentPage}
        pageSize={PAGE_SIZE}
        scrollContainer="#giftCardsList"
        onPageChanged={handlePageChanged}
      />
    );
  };
  if (loading) {
    return <ListLoader />;
  }

  if (errorMsg) {
    return <Alert status="error">{errorMsg}</Alert>;
  }

  const hasFilters = Object.keys(allFilters || {}).length > 0;

  return (
    <div id="giftCardsList">
      {hasFilters && (
        <div className="sui-my-4">
          <FiltersWrapper
            allFilters={allFilters}
            selectedFilters={selectedFilters}
            total={filteredData?.length}
            onChange={handleFiltersChange}
          />
        </div>
      )}
      <div className="sui-p-2">
        <div
          className="sui-grid sui-grid-cols-1 sm:sui-grid-cols-2
        md:sui-grid-cols-3 lg:sui-grid-cols-4 xl:sui-grid-cols-5 sui-gap-8"
          data-testid="plp-list"
        >
          {paginatedData?.map((item) => {
            const configurationId = item?.digital?.configurationId || item?.physical?.configurationId;
            return <ListPod key={configurationId} item={item} />;
          })}
        </div>
      </div>
      <div className="sui-my-4 sui-p-2">{renderPagination()}</div>
    </div>
  );
};

ListWrapperV2.propTypes = {
  preSelectedFilters: PropTypes.oneOfType([PropTypes.object])
};

ListWrapperV2.defaultProps = {
  preSelectedFilters: null
};

export { ListWrapperV2 };
